import { render, staticRenderFns } from "./member-list.vue?vue&type=template&id=438453de&scoped=true&"
import script from "./member-list.vue?vue&type=script&lang=js&"
export * from "./member-list.vue?vue&type=script&lang=js&"
import style0 from "./member-list.vue?vue&type=style&index=0&id=438453de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438453de",
  null
  
)

export default component.exports